import { headerStyles } from "@insite/content-library/Widgets/OrderConfirmation/OrderConfirmationHeader";
import { BaseTheme } from "@insite/mobius/globals/baseTheme";
import breakpointMediaQueries from "@insite/mobius/utilities/breakpointMediaQueries";
import { css } from "styled-components";

headerStyles.title = {
    variant: "h2",
    as: "p",
    css: css`
        @media print {
            font-size: 11px;
        }
        color: rgb(3, 110, 183);
        margin: 0;
    `,
};
headerStyles.buttonGridItem = {
    css: css`
        justify-content: flex-end;
        > div[class^="HiddenStyle"]:last-child {
            > button {
                ${({ theme }: { theme: BaseTheme }) =>
                    breakpointMediaQueries(
                        theme,
                        [
                            null,
                            null,
                            null,
                            css`
                                padding: 0 14px;
                            `,
                        ],
                        "minMax",
                    )}
            }
        }
    `,
    width: [2, 2, 2, 6, 6],
};
headerStyles.buttonsHiddenContainer = {
    below: "lg",
};
